
import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
    root: {},
    hint: {
      color: '#3f505a',
      fontSize: 14,
      fontWeight: 'normal',
      marginBottom: theme.spacing(2),
    },
  }));
  